<template>
<svg xmlns="http://www.w3.org/2000/svg"  class="grafik" viewBox="0 0 875.834 1002.523">
  <g id="Walmdach_Seitenansicht" data-name="Walmdach Seitenansicht" transform="translate(-504.684 -88.477)">
    <g id="Korpus" transform="translate(557.424 377.892)">
      <g id="Rechteck_7" data-name="Rechteck 7" transform="translate(-0.424 0.108)" fill="#f5f5f5" stroke="#000" stroke-width="3">
        <rect width="771" height="493" stroke="none"/>
        <rect x="1.5" y="1.5" width="768" height="490" fill="none"/>
      </g>
      <g id="Fenster" transform="translate(67.173 133.425)">
        <g id="Rechteck_3" data-name="Rechteck 3" transform="translate(0.403 -0.317)" fill="#d6ecff" stroke="#000" stroke-width="2">
          <rect width="146" height="113" stroke="none"/>
          <rect x="1" y="1" width="144" height="111" fill="none"/>
        </g>
        <g id="Rechteck_5" data-name="Rechteck 5" transform="translate(155.403 -0.317)" fill="#d6ecff" stroke="#000" stroke-width="2">
          <rect width="145" height="113" stroke="none"/>
          <rect x="1" y="1" width="143" height="111" fill="none"/>
        </g>
      </g>
      <g id="Fenster-2" data-name="Fenster" transform="translate(414.077 133.425)">
        <g id="Rechteck_3-2" data-name="Rechteck 3" transform="translate(0.498 -0.317)" fill="#d6ecff" stroke="#000" stroke-width="2">
          <rect width="146" height="113" stroke="none"/>
          <rect x="1" y="1" width="144" height="111" fill="none"/>
        </g>
        <g id="Rechteck_5-2" data-name="Rechteck 5" transform="translate(155.498 -0.317)" fill="#d6ecff" stroke="#000" stroke-width="2">
          <rect width="145" height="113" stroke="none"/>
          <rect x="1" y="1" width="143" height="111" fill="none"/>
        </g>
      </g>
    </g>
    <g id="Dach" transform="translate(504.684 88.477)">
      <path id="Pfad_220" data-name="Pfad 220" d="M0,0H770.184V6.088H0Z" transform="translate(52.741 288.375)" fill="#f5f5f5"/>
      <path id="Pfad_219" data-name="Pfad 219" d="M437.821,1.048,875.759,310.255H0l108.181-76.4Z" transform="translate(0.001 -1.048)" fill="#006fba"/>
      <path id="Pfad_221" data-name="Pfad 221" d="M462,309.584" transform="translate(400.952 17.099)" fill="none" stroke="#006fba" stroke-width="24"/>
    </g>
    <g id="Winkel" transform="translate(1174.147 276.238)">
      <line id="Linie_10" data-name="Linie 10" x1="206.118" transform="translate(0.252 121.438)" fill="none" stroke="#fff" stroke-width="3"/>
      <path id="Pfad_223" data-name="Pfad 223" d="M3240.915,328.527s-39.121,10.478-58.793,41.048-19.9,81.232-19.9,81.232" transform="translate(-3162.226 -328.527)" fill="none" stroke="#fff" stroke-width="4"/>
      <text id="α" transform="translate(58.853 90.762)" fill="#fff" font-size="61" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">α</tspan></text>
    </g>
    <g id="Pfeil" transform="translate(521.736 911.869) rotate(-90)">
      <line id="Linie_6" data-name="Linie 6" y1="796.96" transform="translate(13.565 21.861)" fill="none" stroke="#006fba" stroke-width="5"/>
      <g id="Polygon_1" data-name="Polygon 1" transform="translate(0)" fill="#006fba">
        <path d="M 27.63980674743652 23.14512062072754 L 0.8855149149894714 23.14512062072754 L 14.26266098022461 0.9680362343788147 L 27.63980674743652 23.14512062072754 Z" stroke="none"/>
        <path d="M 14.26266098022461 1.936080932617188 L 1.771034240722656 22.64512062072754 L 26.75428771972656 22.64512062072754 L 14.26266098022461 1.936080932617188 M 14.26266098022461 1.9073486328125e-06 L 28.52532005310059 23.64512062072754 L 1.9073486328125e-06 23.64512062072754 L 14.26266098022461 1.9073486328125e-06 Z" stroke="none" fill="#006fba"/>
      </g>
      <g id="Polygon_2" data-name="Polygon 2" transform="translate(28.525 836.181) rotate(180)" fill="#006fba">
        <path d="M 27.59961128234863 21.25351524353027 L 0.9257111549377441 21.25351524353027 L 14.26266098022461 0.9118961095809937 L 27.59961128234863 21.25351524353027 Z" stroke="none"/>
        <path d="M 14.26266098022461 1.823797225952148 L 1.851421356201172 20.75351524353027 L 26.67390060424805 20.75351524353027 L 14.26266098022461 1.823797225952148 M 14.26266098022461 -3.814697265625e-06 L 28.52532005310059 21.75351524353027 L 1.9073486328125e-06 21.75351524353027 L 14.26266098022461 -3.814697265625e-06 Z" stroke="none" fill="#006fba"/>
      </g>
    </g>
    <g id="Pfeil_Helpers" data-name="Pfeil Helpers" transform="translate(1354.631 401.141) rotate(90)">
      <line id="Linie_7" data-name="Linie 7" x2="480.085" transform="translate(0 824.135)" fill="none" stroke="#006fba" stroke-width="5" stroke-dasharray="11" opacity="0.75"/>
      <line id="Linie_8" data-name="Linie 8" x2="480.962" transform="translate(0.963)" fill="none" stroke="#006fba" stroke-width="5" stroke-dasharray="11" opacity="0.75"/>
    </g>
    <text id="Trauflänge" transform="translate(920 957)" fill="#006fba" font-size="55" font-family="SegoeUI, Segoe UI"><tspan x="-126.53" y="0">Trauflänge (kurz)</tspan></text>
    <text id="placeholder_giebellaenge" transform="translate(965 1020)" fill="#006fba" font-size="55" font-family="SegoeUI, Segoe UI"><tspan x="-7.533" y="0">{{giebellaenge}}m </tspan></text>
    <text id="placeholder_winkel" transform="translate(1030 364)" fill="#fff" font-size="55" font-family="SegoeUI, Segoe UI"><tspan x="-7.533" y="0">{{dachneigung}}° </tspan></text>
  </g>
</svg>

</template>

<script> 
import {mapState} from 'vuex'

export default {
    name: "WalmdachSeitenansicht",
    computed: {
        ...mapState({
            giebellaenge: state => state.inputs.walmtrauflaenge,
            dachneigung: state => state.inputs.dachneigung,
        }),
    }
}

</script>

<style scoped>
.grafik
{
  height: 100%;
}
</style>